var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _c("c-datepicker", {
                  attrs: {
                    range: true,
                    defaultStart: "-6M",
                    defaultEnd: "6M",
                    label: "작업기간",
                    name: "permitDates",
                  },
                  model: {
                    value: _vm.searchParam.permitDates,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "permitDates", $$v)
                    },
                    expression: "searchParam.permitDates",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" },
              [
                _c("c-vendor", {
                  attrs: {
                    type: "search",
                    label: "신청업체",
                    name: "vendorCd",
                  },
                  model: {
                    value: _vm.searchParam.vendorCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "vendorCd", $$v)
                    },
                    expression: "searchParam.vendorCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" },
              [
                _c("c-select", {
                  attrs: {
                    type: "search",
                    stepperGrpCd: "SWP_STEP_CD",
                    itemText: "stepperMstNm",
                    itemValue: "stepperMstCd",
                    name: "swpStepCd",
                    label: "진행단계",
                  },
                  model: {
                    value: _vm.searchParam.swpStepCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "swpStepCd", $$v)
                    },
                    expression: "searchParam.swpStepCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" },
              [
                _c("c-select", {
                  attrs: {
                    type: "search",
                    codeGroupCd: "SOP_PERMIT_TYPE_CD",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "permitTypeCd",
                    label: "허가서구분",
                  },
                  model: {
                    value: _vm.searchParam.permitTypeCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "permitTypeCd", $$v)
                    },
                    expression: "searchParam.permitTypeCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" },
              [
                _c("c-select", {
                  attrs: {
                    type: "search",
                    codeGroupCd: "SOP_SUPPLEMENT_WORK_TYPE_CD",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "supplementWorkTypeCd",
                    label: "보충작업",
                  },
                  model: {
                    value: _vm.searchParam.supplementWorkTypeCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "supplementWorkTypeCd", $$v)
                    },
                    expression: "searchParam.supplementWorkTypeCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("div", { staticClass: "card cardcontents" }, [
        _c(
          "div",
          { staticClass: "card-body qtable-card-body" },
          [
            _c("q-table", {
              staticClass: "qtable-card",
              attrs: {
                grid: "",
                title: "",
                data: _vm.grid.data,
                columns: _vm.grid.columns,
                "hide-header": "",
                "hide-bottom": "",
                "rows-per-page-options": [0],
                "virtual-scroll": "",
              },
              scopedSlots: _vm._u([
                {
                  key: "item",
                  fn: function (props) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3",
                        },
                        [
                          _c(
                            "q-card",
                            {
                              staticClass: "mobileTableCardLayer",
                              on: {
                                click: function ($event) {
                                  return _vm.linkClick(props.row)
                                },
                              },
                            },
                            [
                              _c(
                                "q-card-section",
                                { staticClass: "grid-card-etc" },
                                [
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "text-grid-etc",
                                        _vm.getColorStatus(props.row.swpStepCd),
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(props.row.swpStepName) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "text-grid-etc",
                                        _vm.getColorStatus2(
                                          props.row.permitTypeCd
                                        ),
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(props.row.permitTypeName) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-grid-etc txt-box-grid text-gray-box",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            props.row.applicationDeptName
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c("q-card-section", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-grid-title q-mt-sm q-mb-xs",
                                  },
                                  [_vm._v(_vm._s(props.row.workSummary))]
                                ),
                              ]),
                              _c(
                                "q-card-section",
                                { staticClass: "grid-card-etc" },
                                [
                                  _c("div", { staticClass: "text-grid-etc" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(props.row.permitDate) +
                                        " | " +
                                        _vm._s(
                                          _vm.getSupWorkName(
                                            props.row.supplementWorkTypeNames
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm.grid.data.length === 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3",
                  },
                  [
                    _c(
                      "q-card",
                      { staticClass: "mobileTableCardLayer" },
                      [
                        _c(
                          "q-card-section",
                          { staticClass: "text-center" },
                          [
                            _c("q-card-section", { staticClass: "q-pt-xs" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-grid-title q-mt-sm q-mb-xs",
                                },
                                [_vm._v("데이터가 존재하지 않습니다.")]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }